import * as React from "react"
import Relay from "react-relay"
import Immutable from "immutable"
import classnames from "classnames"
import { isomorphicVars } from "../../scripts/isomorphicVars"
import _ from "lodash"
import update from "react-addons-update"
import { ResourceRoute, SearchRoute } from "../../relay/routes"
import InlineSearch from "./InlineSearch"
import MediaUpload from "./MediaUpload"
import Icon from "../elements/Icon"
import InlineResource from "../modules/InlineResource"
import ChooseContentType from "../modules/ChooseContentType"
//import ContributionResource from '../modules/ContributionResource';
import { saveArticle } from "../../scripts/backend"
import ArticleMetaShare from "../modules/ArticleMetaShare"
import RichTextEditor from "../elements/RichTextEditor"
import { injectIntl, FormattedMessage, FormattedHTMLMessage } from "react-intl"
import { isKeyClick } from "../../scripts/utils"
import sharedMessages from "../../messages/index"
import { messages as licenceMessages } from "../../messages/licenses"
import articleMessages from "../../messages/article"
import settingsMessages from "../../messages/settings"
import { getAccountSettings } from "../../scripts/accountSettings"
import { getStyles, getStyleTag } from "../../styles/dynamicStyles"
import State from "../../stores/State"
import ReactSVG from "react-svg"
import moment from "moment"
import { getCommentsRedirectLink } from "../../utils/url"
import CommentsWidget from "../elements/CommentsWidget"
import { filterHTML } from "../../scripts/xss"

/**
 * Concept:
 *
 * We have a list ( this.state.sections)
 *
 * We add data to this list, we use this data to render components
 * via _renderSection and _renderEditSection
 *
 */
const SAVED = "saved"
const UNSAVED = "unsaved"
const SAVING = "saving"

class Article extends React.Component {
  constructor(props) {
    super(props)

    const {
      description,
      contributed_at,
      subject,
      license,
      coverage
    } = props.resource ? JSON.parse(props.resource.custom_fields) : {}

    this.state = {
      editing: props.editing, // || this.props.canEdit, `canEdit` was forcing admins (and original author?) into edit mode of a item, so they could never 'view' the item...
      saveState: SAVED,
      access_rights: null,
      id: (props.resource && props.resource.id) || null,
      title: (props.resource && props.resource.title) || "",
      contributed_at:
        (props.resource && contributed_at && contributed_at.value) || "",
      updated_at: (props.resource && props.resource.updated_at) || "",
      subtitle: (props.resource && description && description.value) || "",
      sections: Immutable.fromJS(this._loadSections(props.resource)),
      agreeToLicense: props.resource && license && license.value !== "",
      errors: {},
      fields: {
        creator: props.resource && props.resource.creator,
        tags: props.resource && subject ? subject.value.join(", ") : "",
        date: props.resource && props.resource.date,
        coverage: props.resource && coverage ? coverage.value : ""
      },
      loggedIn: State.get("loggedIn"),
      signUpLink: "",
      signInLink: ""
    }

    const { api_endpoint: apiEndpoint } = isomorphicVars()
    const {
      settings: { disqus_short_name: disqusShortName }
    } = getAccountSettings(
      props.intl.formatMessage(settingsMessages.authenticAccountId)
    )
    const { public_url: publicUrl } = isomorphicVars()
    this._public_url = publicUrl
    this._disqus_shortname = disqusShortName
    this._api_endpoint = apiEndpoint
  }

  componentDidMount() {
    this.setState({
      signUpLink: getCommentsRedirectLink("register"),
      signInLink: getCommentsRedirectLink("login")
    })
  }

  render() {
    const { resource, canEdit, intl } = this.props
    const { loggedIn } = this.state
    const type = resource && resource.type
    const editing = this.state.editing && canEdit
    const saveState = this.state.saveState
    const errors = this.state.errors
    const {
      settings: {
        style: { content: contentType }
      },
      name: siteName,
      authentic_account_id: authenticAccountId
    } = getAccountSettings(
      intl.formatMessage(settingsMessages.authenticAccountId)
    )

    const commentsIframeUrl = `https://d2iun5pubia9jk.cloudfront.net/index.html?apiEndpoint=${
      this._api_endpoint
    }&resourceId=${
      resource ? resource.id : ""
    }&authenticAccountId=${authenticAccountId}&userFullName=${this.props.user
      .name || ""}&signUpLink=${this.state.signUpLink}&signInLink=${
      this.state.signInLink
    }&token=${State.get("tokenString")}#tab-item-comments`

    return (
      <article
        className={classnames("c-article min-height-page", {
          "c-create": editing,
          "state-article-saving": saveState === SAVING
        })}
        itemScope
        itemType="http://schema.org/Article"
      >
        {getStyleTag([
          "content-medium",
          "c-article",
          "button--lowlight",
          "form-message",
          "editable-item",
          "editable-item__actions__button"
        ])}
        {editing && (
          <header
            className={classnames("c-article__header", {
              "content-medium": contentType == "type1"
            })}
            style={getStyles("c-article__header")}
          >
            {errors.title && (
              <span className="form-message state-error">{errors.title}</span>
            )}
            {contentType == "type1" && <h1>Upload Article</h1>}
            {contentType == "type1" && (
              <label style={getStyles("c-article__label")}>
                <FormattedMessage {...articleMessages.addTitle} />*
              </label>
            )}
            <input
              className={classnames("c-article__title required", {
                "state-invalid": errors.title
              })}
              style={getStyles("c-article__input")}
              value={this.state.title || ""}
              onChange={e =>
                this.setState({ title: e.target.value, saveState: UNSAVED })
              }
              type="text"
              placeholder={
                contentType == "default"
                  ? intl.formatMessage(articleMessages.addTitle)
                  : ""
              }
              name="title"
            />
            {contentType == "type1" && (
              <label style={getStyles("c-article__label")}>
                <FormattedMessage {...articleMessages.addIntroduction} />
              </label>
            )}
            <textarea
              className="c-article__intro"
              value={this.state.subtitle}
              onChange={e =>
                this.setState({ subtitle: e.target.value, saveState: UNSAVED })
              }
              placeholder={
                contentType == "default"
                  ? intl.formatMessage(articleMessages.addIntroduction)
                  : ""
              }
              name="subtitle"
              rows="3"
              style={getStyles("c-article__intro")}
            />
          </header>
        )}

        {!editing && (
          <header className="c-article__header">
            {getStyleTag(["c-article__pretitle"])}
            <h5 className="c-article__pretitle">
              <FormattedMessage {...articleMessages.communityContributed} />
            </h5>
            <h1 className="c-article__title" itemProp="name headline">
              {this.state.title}
            </h1>
            <span
              className="hide for-schema-markup-only"
              itemProp="publisher"
              itemScope
              itemType="http://schema.org/Organization"
            >
              <span className="hide for-schema-markup-only" itemProp="name">
                {siteName}
              </span>
            </span>
            <span
              className="hide for-schema-markup-only"
              itemProp="datePublished"
            >
              {this.state.contributed_at}
            </span>
            <span
              className="hide for-schema-markup-only"
              itemProp="dateModified"
            >
              {this.state.updated_at}
            </span>
            {this.state.fields.creator && (
              <p className="c-article__author">
                <em>by</em> {this.state.fields.creator}
              </p>
            )}
            <div
              className="c-article__intro"
              itemProp="articleBody"
              dangerouslySetInnerHTML={{
                __html: filterHTML(this.state.subtitle)
              }}
            />
          </header>
        )}

        {/*

                        This is where sections are rendered

                        The "main loop"

                        */}
        <div
          className={classnames({
            "content-medium": contentType == "type1",
            "c-article__content": contentType == "default"
          })}
          itemProp="articleBody"
        >
          {this.state.sections.map(
            (section, idx) =>
              canEdit
                ? [
                    this._chooseContentType(idx),
                    this._renderSection(section, idx)
                  ]
                : this._renderSection(section, idx)
          )}
        </div>

        {editing &&
          this._lastType() !== "resource-search" && (
            <div className="content-medium">
              {this._chooseContentType(this.state.sections.size)}
            </div>
          )}

        {this._lastType() !== "resource-search" && (
          <footer
            className={classnames({
              "content-medium": contentType == "type1",
              "c-article__footer": contentType == "default",
              "state-is-edit-style": editing || saveState != SAVED
            })}
          >
            {canEdit &&
              (editing || saveState != SAVED) && (
                <div>
                  <h2>
                    <FormattedMessage
                      id="article.attribute-and-publish"
                      defaultMessage="Attribute &amp; Publish your article"
                    />
                  </h2>

                  <div id="meta-info">{this._renderMeta()}</div>

                  <div
                    className="form-actions"
                    style={getStyles("form-actions")}
                  >
                    {errors.form && (
                      <span className="form-message state-error">
                        {errors.form}
                      </span>
                    )}

                    {resource &&
                      saveState == SAVED && (
                        <button
                          className="button button--lowlight"
                          type="button"
                          onKeyPress={e => {
                            isKeyClick(e) ? document.location.reload() : null
                          }}
                          onClick={e =>
                            //Hack just reloading the page as we can't handle undo
                            //Hack, to remove ?edit=1 which might be present
                            (window.location = window.location.pathname)
                          }
                        >
                          Close
                        </button>
                      )}

                    {resource &&
                      saveState != SAVED && (
                        <button
                          className="button button--alert-subtle"
                          type="button"
                          onKeyPress={e =>
                            isKeyClick(e) ? document.location.reload() : null
                          }
                          onClick={e =>
                            //Hack just reloading the page as we can't handle undo
                            //Hack, to remove ?edit=1 which might be present
                            (window.location = window.location.pathname)
                          }
                        >
                          {getStyleTag("button--alert-subtle")}
                          Discard changes
                        </button>
                      )}

                    {(saveState != SAVED || this._isDraft()) && (
                      <button
                        className={classnames(
                          "button button--can-load pull-right",
                          {
                            "state-loading": this.state.saveState == SAVING
                          }
                        )}
                        type="button"
                        onKeyPress={e =>
                          isKeyClick(e) ? this._save(e, "published") : null
                        }
                        onClick={e => this._save(e, "published")}
                      >
                        {!resource || this._isDraft()
                          ? intl.formatMessage(articleMessages.publish)
                          : intl.formatMessage(articleMessages.saveChanges)}
                      </button>
                    )}

                    {saveState != SAVED &&
                      this._isDraft() && (
                        <button
                          className={classnames(
                            "button button--can-load pull-right",
                            {
                              "state-loading": this.state.saveState === SAVING
                            }
                          )}
                          type="button"
                          onKeyPress={e =>
                            isKeyClick(e) ? this._save(e, "draft") : null
                          }
                          onClick={e => this._save(e, "draft")}
                        >
                          <FormattedMessage
                            id="article.save-draft"
                            defaultMessage="Save Draft"
                          />
                        </button>
                      )}

                    {/* editing && saveState != SAVED &&
                                <button className="button button--lowlight pull-right"
                                    onKeyPress={ e => { isKeyClick(e) ? this._edit(e) : null; } }
                                    onClick={this._edit}
                                    type="button"
                                >Preview</button> */}

                    {!editing && (
                      <button
                        className="button button--lowlight pull-right"
                        onKeyPress={e => (isKeyClick(e) ? this._edit(e) : null)}
                        onClick={this._edit}
                        type="button"
                      >
                        <FormattedMessage
                          id="article-continue-editing"
                          defaultMessage="Continue editing"
                        />
                      </button>
                    )}
                  </div>
                </div>
              )}

            {!editing &&
              this.state.saveState == SAVED && (
                <div className="c-article__footer-inner">
                  <div className="c-article__footer-col c-article__footer-col--main">
                    <div className="c-comment-list c-comment-list--maxwidth">
                      <CommentsWidget
                        id="iframe-comments"
                        src={commentsIframeUrl}
                      />
                    </div>
                  </div>
                  <div className="c-article__footer-col c-article__footer-col--sub">
                    <ArticleMetaShare
                      resource={resource}
                      type={type}
                      active={resource}
                      loggedIn={loggedIn}
                    />

                    {this.props.canEdit && (
                      <button
                        onKeyPress={e => (isKeyClick(e) ? this._edit(e) : null)}
                        onClick={this._edit}
                        className="edit-link button button--small button--lowlight"
                        type="button"
                      >
                        <FormattedMessage
                          id="article.edit-article"
                          defaultMessage="Edit article"
                        />
                      </button>
                    )}
                  </div>
                </div>
              )}
          </footer>
        )}
      </article>
    )
  }

  _renderSection = (section, idx) => {
    const type = section.get("type")
    const data = section.get("data")
    const { intl, canEdit } = this.props
    const editing = section.get("editing") && canEdit
    const {
      settings: {
        style: { content: contentType }
      }
    } = getAccountSettings(
      intl.formatMessage(settingsMessages.authenticAccountId)
    )

    switch (type) {
      case "resource-search":
        const mediaType = data.get("mediaType")
        return canEdit ? (
          <div key={idx} className="c-article__add-resource clearfix">
            <div className="editable-item">
              <MediaUpload
                type={mediaType}
                resource={null}
                handleSaved={res =>
                  this._selectInlineResource(idx, res.resource_id)
                }
                handleDrop={files =>
                  this._setSectionData(idx, "hideSearch", files.length > 0)
                }
                updateParentFields={value =>
                  this.setState({
                    fields: { ...this.state.fields, ...value }
                  })
                }
              />
              <div
                style={getStyles(["without-paddings", "actions-column"])}
                className="editable-item__actions"
              >
                <button
                  type="button"
                  style={getStyles(["c-button__icon", "c-button__col"])}
                  className={"button editable-item__btn--alert"}
                  onKeyPress={e =>
                    isKeyClick(e) ? this._removeSection(idx) : null
                  }
                  onClick={e => {
                    e.preventDefault()
                    this._removeSection(idx)
                  }}
                  title={"Remove " + mediaType}
                >
                  <Icon icon="cross" />
                </button>
              </div>
            </div>
            {!data.get("hideSearch") && (
              <Relay.RootContainer
                Component={InlineSearch}
                route={
                  new SearchRoute({
                    handleResourceClick: resource =>
                      this._selectInlineResource(idx, resource.id),
                    mediaType: mediaType
                  })
                }
              />
            )}
          </div>
        ) : null

      case "resource":
        if (data.get("id")) {
          return (
            <Relay.RootContainer
              key={idx}
              Component={InlineResource}
              route={
                new ResourceRoute({
                  id: data.get("id"),
                  editing: editing,
                  editable: canEdit,
                  align: data.get("align"),
                  description: data.get("description"),
                  handleChangeDescription: description =>
                    this._setSectionData(idx, "description", description),
                  handleAlign: align =>
                    this._setSectionData(idx, "align", align),
                  handleMoveUp: () => this._move(idx, idx - 1),
                  handleMoveDown: () => this._move(idx, idx + 1),
                  handleResourceEditToggle: () =>
                    this._setSectionEditing(idx, !editing),
                  handleImageSrc: src =>
                    this._setSectionData(idx, "image_src", src),
                  handleResourceRemove: () => this._removeSection(idx)
                })
              }
            />
          )
        }
        break
      case "text":
        const value = data.get("value")

        return (
          <div
            className={classnames("typography editable-item", {
              "text-editor": editing,
              "is-editing": editing,
              "not-editing": !editing
            })}
            key={idx}
          >
            {editing && (
              <RichTextEditor
                value={value}
                onChange={value => this._setSectionData(idx, "value", value)}
              />
            )}
            {!editing && (
              <div
                key={idx}
                dangerouslySetInnerHTML={{
                  __html: RichTextEditor.RTEValuetoString(filterHTML(value))
                }}
                onClick={e => this._setSectionEditing(idx, !editing)}
              />
            )}
            {getStyleTag("c-button__icon")}
            {canEdit &&
              contentType == "type1" && (
                <div style={getStyles("actions-column")}>
                  {!editing && (
                    <button
                      type="button"
                      style={getStyles(["c-button__icon", "c-button__col"])}
                      className="c-button__icon"
                      onKeyPress={e =>
                        isKeyClick(e) ? this._move(idx, idx - 1) : null
                      }
                      onClick={e => this._setSectionEditing(idx, !editing)}
                      title={intl.formatMessage(articleMessages.editSection)}
                    >
                      <ReactSVG src="../../images/edit.svg" />
                    </button>
                  )}
                  {!editing && (
                    <button
                      type="button"
                      style={getStyles(["c-button__icon", "c-button__col"])}
                      className="c-button__icon"
                      onKeyPress={e =>
                        isKeyClick(e) ? this._removeSection(idx) : null
                      }
                      onClick={e => {
                        e.preventDefault()
                        this._removeSection(idx)
                      }}
                      title={intl.formatMessage(articleMessages.deleteSection)}
                    >
                      <Icon icon="cross" />
                    </button>
                  )}
                  {editing && (
                    <button
                      type="button"
                      style={getStyles(["c-button__icon", "c-button__col"])}
                      className="c-button__icon"
                      onKeyPress={e =>
                        isKeyClick(e) ? this._move(idx, idx - 1) : null
                      }
                      onClick={e => this._move(idx, idx - 1)}
                      title={intl.formatMessage(
                        articleMessages.moveSectionUpwards
                      )}
                    >
                      <ReactSVG src="../../images/sort-ascending.svg" />
                    </button>
                  )}
                  {editing && (
                    <button
                      type="button"
                      style={getStyles(["c-button__icon", "c-button__col"])}
                      className="c-button__icon"
                      onKeyPress={e =>
                        isKeyClick(e) ? this._move(idx, idx + 1) : null
                      }
                      onClick={e => this._move(idx, idx + 1)}
                      title={intl.formatMessage(
                        articleMessages.moveSectionDownwards
                      )}
                    >
                      <ReactSVG src="../../images/sort-descending.svg" />
                    </button>
                  )}
                </div>
              )}
            {canEdit &&
              (editing || (!editing && contentType == "default")) && (
                <div
                  className={
                    contentType == "default" &&
                    "editable-item__actions editable-item__actions--atbottom"
                  }
                  style={getStyles("actions-row")}
                >
                  <button
                    type="button"
                    style={getStyles("save-btn")}
                    className={
                      contentType == "default" &&
                      "button editable-item__btn--edit"
                    }
                    onKeyPress={e => {
                      isKeyClick(e)
                        ? this._setSectionEditing(idx, !editing)
                        : null
                    }}
                    onClick={e => this._setSectionEditing(idx, !editing)}
                    title={
                      editing
                        ? intl.formatMessage(
                            articleMessages.finishEditingSection
                          )
                        : intl.formatMessage(articleMessages.editSection)
                    }
                  >
                    {contentType == "type1" ? (
                      <span>Save</span>
                    ) : editing ? (
                      <Icon icon="tick" />
                    ) : (
                      <Icon icon="edit" />
                    )}
                  </button>
                  {editing &&
                    contentType == "default" && (
                      <button
                        type="button"
                        className="button editable-item__btn-secondary"
                        onKeyPress={e =>
                          isKeyClick(e) ? this._move(idx, idx - 1) : null
                        }
                        onClick={e => this._move(idx, idx - 1)}
                        title={intl.formatMessage(
                          articleMessages.moveSectionUpwards
                        )}
                      >
                        <Icon icon="list-move-up" />
                      </button>
                    )}
                  {editing &&
                    contentType == "default" && (
                      <button
                        type="button"
                        className="button editable-item__btn-secondary"
                        onKeyPress={e =>
                          isKeyClick(e) ? this._move(idx, idx + 1) : null
                        }
                        onClick={e => this._move(idx, idx + 1)}
                        title={intl.formatMessage(
                          articleMessages.moveSectionDownwards
                        )}
                      >
                        <Icon icon="list-move-down" />
                      </button>
                    )}
                  {editing && (
                    <button
                      type="button"
                      style={getStyles("cancel-btn")}
                      className={
                        contentType == "default" &&
                        "button editable-item__btn--alert editable-item__btn-secondary"
                      }
                      onKeyPress={e =>
                        isKeyClick(e) ? this._removeSection(idx) : null
                      }
                      onClick={e => {
                        e.preventDefault()
                        this._removeSection(idx)
                      }}
                      title={intl.formatMessage(articleMessages.deleteSection)}
                    >
                      {contentType == "type1" ? (
                        <span>Cancel</span>
                      ) : (
                        <Icon icon="cross" />
                      )}
                    </button>
                  )}
                </div>
              )}
          </div>
        )
    }
  }

  _renderMeta = () => {
    const { intl } = this.props
    const { errors, fields } = this.state
    const typeName = intl.formatMessage(sharedMessages.typeArticle)
    const disableFields = !this.state.editing

    return (
      <div>
        <div className="row nested">
          <div className="small-12 medium-6 columns">
            <label htmlFor="date">
              <FormattedMessage {...sharedMessages.formDate} />
            </label>
            {errors.date && (
              <span className="form-message state-error">{errors.date}</span>
            )}
            <input
              aria-describedby="imageUploadDateHelp"
              type="text"
              id="date"
              name="date"
              value={fields.date || ""}
              onChange={this._changeValue}
              disabled={disableFields}
              placeholder="YYYY-MM-DD"
            />
            <p
              className="help-text"
              id="imageUploadDateHelp"
              style={getStyles("help-text")}
            >
              <FormattedHTMLMessage {...sharedMessages.edtfDateInstructions} />
            </p>
          </div>
          <div className="small-12 medium-6 columns">
            <label htmlFor="coverage">
              <FormattedMessage {...sharedMessages.formLocation} />
            </label>
            {errors.coverage && (
              <span className="form-message state-error">
                {errors.coverage}
              </span>
            )}
            <input
              type="text"
              id="coverage"
              name="coverage"
              value={fields.coverage || ""}
              onChange={this._changeValue}
              disabled={disableFields}
            />
          </div>
        </div>

        <label htmlFor="tags">
          <FormattedMessage {...sharedMessages.formTags} />
        </label>
        {errors.tags && (
          <span className="form-message state-error">{errors.tags}</span>
        )}
        <input
          aria-describedby="imageUploadTagHelp"
          type="text"
          id="tags"
          name="tags"
          value={fields.tags || ""}
          onChange={this._changeValue}
          disabled={disableFields}
        />
        <p
          className="help-text"
          id="imageUploadTagHelp"
          style={getStyles("help-text")}
        >
          <FormattedMessage {...sharedMessages.formTagsHelp} />
        </p>

        <label htmlFor="creator">
          <FormattedMessage {...sharedMessages.formCreator} />
        </label>
        {errors.creator && (
          <span className="form-message state-error">{errors.creator}</span>
        )}
        <input
          aria-describedby="creatorHelp"
          className={classnames({ "state-invalid": errors.creator })}
          type="text"
          id="creator"
          name="creator"
          value={fields.creator || ""}
          onChange={this._changeValue}
          disabled={disableFields}
        />
        <p
          className="help-text"
          id="creatorHelp"
          style={getStyles("help-text")}
        >
          <FormattedMessage
            {...sharedMessages.formCreatorHelp}
            values={{ type: typeName.toLowerCase() }}
          />
        </p>

        <label>
          <input
            type="checkbox"
            name="license"
            checked={this.state.agreeToLicense}
            onChange={e =>
              this.setState({
                agreeToLicense: !this.state.agreeToLicense,
                saveState: UNSAVED
              })
            }
            value="cc-by"
          />
          <FormattedMessage
            {...sharedMessages.formLicenseReuse}
            values={{
              type: intl.formatMessage(articleMessages.content),
              license: (
                <a
                  href="https://creativecommons.org/licenses/by/4.0/"
                  target="_blank"
                >
                  {intl.formatMessage(
                    licenceMessages.createCommonsAttributeLicense
                  )}
                </a>
              )
            }}
          />
        </label>
        {errors.agreeToLicense && (
          <span className="form-message state-error">
            {errors.agreeToLicense}
          </span>
        )}
      </div>
    )
  }

  _changeValue = e => {
    const field = e.target.getAttribute("name")
    const value = e.target.value

    this.setState({
      fields: update(this.state.fields, { $merge: { [field]: value } }),
      saveState: UNSAVED
    })

    if (this.props.handleUnsaved) {
      this.props.handleUnsaved()
    }
  }

  _move = (idx, toIdx) => {
    if (toIdx < 0) return
    if (toIdx > this.state.sections.size - 1) return

    const item = this.state.sections.get(idx)

    if (item) {
      this.setState({
        sections: this.state.sections.delete(idx).insert(toIdx, item)
      })
    }
  }

  _loadSections = resource => {
    if (!resource) {
      return []
    }

    let json = null

    if (resource.files && Array.isArray(resource.files)) {
      for (const file of resource.files) {
        if (file && file.contents) {
          json = file.contents
          break
        }
      }
    }

    //TODO handle errors here
    return (json && JSON.parse(json)) || []
  }

  _addResourceSearch = (idx, type) => {
    this._insertSection(idx, "resource-search", { mediaType: type })
  }

  _addText = idx => {
    this._insertSection(idx, "text", { value: "" })
  }

  _selectInlineResource = (searchIndex, uuid) => {
    //Replace the search box
    this._replaceSection(searchIndex, "resource", { id: uuid, align: "inline" })
  }

  _chooseContentType = (idx = 0) => {
    const isLast = idx === this.state.sections.size
    return (
      <section key={"add-at" + idx}>
        <ChooseContentType
          isLast={isLast}
          idx={idx}
          handleAddText={this._addText}
          handleAddMedia={this._addResourceSearch}
        />
      </section>
    )
  }

  _insertSection = (idx, type, data = {}) => {
    return new Promise((resolve, reject) => {
      this.setState(
        {
          sections: this.state.sections.insert(
            idx,
            Immutable.fromJS({
              type: type,
              data: data,
              editing: true
            })
          ),
          saveState: UNSAVED
        },
        resolve
      )
    }).then(() => {
      this._stopEditOthers(idx)
      this._cleanUp(idx)
    })
  }

  _replaceSection = (idx, type, data = {}) => {
    this.setState({
      sections: this.state.sections.set(
        idx,
        Immutable.fromJS({
          type: type,
          data: data,
          editing: true
        })
      ),
      saveState: UNSAVED
    })
  }

  _removeSection = idx => {
    if (
      confirm(
        this.props.intl.formatMessage(articleMessages.removeSectionConfirm)
      )
    ) {
      this.setState({
        sections: this.state.sections.delete(idx),
        saveState: UNSAVED
      })
    }
  }

  _setSectionData = (idx, key, value) => {
    this.setState({
      sections: this.state.sections.setIn([idx, "data", key], value),
      saveState: UNSAVED
    })
  }

  _setSectionEditing = (idx, editing, stopOthers = true) => {
    return new Promise(resolve => {
      if (stopOthers && editing) {
        this._stopEditOthers(idx)
      }
      this.setState(
        {
          sections: this.state.sections.setIn([idx, "editing"], editing)
        },
        resolve
      )
    })
  }

  _stopEditOthers = keepIdx => {
    return new Promise(resolve => {
      this.setState(
        {
          sections: this.state.sections.map(
            (section, idx) =>
              idx !== keepIdx ? section.set("editing", false) : section
          )
        },
        resolve
      )
    })
  }

  _cleanUp = keepIdx => {
    return new Promise(resolve => {
      const filtered = this.state.sections.filter((section, idx) => {
        if (idx === keepIdx) {
          return true // Always keep the thing we are editing
        }
        switch (section.get("type")) {
          case "text": // remove if no text set ( note this doesn't really work as well as I'd like as we can have empty html <p><br /></p> )
            return !!section.getIn(["data", "value"])
          case "resource-search":
            return false // remove if nothing was selected
        }
        return true // everything else can stay
      })
      this.setState(
        {
          sections: filtered
        },
        resolve
      )
    })
  }

  _lastType = () => {
    return this.state.sections.last() && this.state.sections.last().get("type")
  }

  _isDraft = () => {
    // _save will set this in state, so check there first
    // this is hacky because we aren't using relay to do the mutation
    return (
      this.state.access_rights === "draft" ||
      !this.props.resource ||
      this.props.resource.access_rights === "draft"
    )
  }

  _validate = () => {
    const errors = {}
    const { intl } = this.props

    //MVP BRO MVP
    if (!this.state.title) {
      errors.title = intl.formatMessage(articleMessages.errorEnterTitle)
    }

    if (!this.state.agreeToLicense) {
      errors.agreeToLicense = intl.formatMessage(
        articleMessages.errorAgreeToLicense
      )
    }

    return errors
  }

  _edit = e => {
    if (e) e.preventDefault()

    this.setState({
      editing: !this.state.editing
    })
  }

  _save = (e, status) => {
    if (e) e.preventDefault()

    // return out if we are already in progress of saving
    if (this.state.saveState === SAVING) {
      return
    }

    const errors = this._validate()

    this.setState({
      errors: errors
    })

    if (!_.isEmpty(errors)) {
      return
    }

    this.setState({
      saveState: SAVING
    })

    // create a JSON friendly representation or our section state
    const save = this.state.sections.reduce((save, section) => {
      const data = section.get("data")
      const type = section.get("type")

      switch (type) {
        case "text":
          //Replace the rich text editor state object with html string
          save.push({
            type: type,
            data: {
              ...data.delete("value").toJS(),
              value: data.get("value").toString("html")
            }
          })
          break

        case "resource":
          const description = data.get("description")
          if (description && typeof description !== "string") {
            //Replace the rich text editor state object with html string
            save.push({
              type: type,
              data: {
                ...data.delete("description").toJS(),
                description: description.toString("html")
              }
            })
          } else {
            save.push({ type: type, data: data.toJS() })
          }
          break

        case "resource-search":
          //Don't save these
          break

        default:
          save.push({ type: type, data: data.toJS() })
      }

      return save
    }, [])

    const currentDate = moment ? moment().format("YYYY-MM-DD") : null
    //Find the first resource in this article
    const firstResource = _.first(save, { type: "resource" })
    const {
      fields: { tags }
    } = this.state
    //Convert tags string into array
    const tagsArr = tags && tags.split(",").map(item => item.trim())

    // Send to the API
    saveArticle({
      ...this.state.fields,
      tags: tagsArr || [],
      id: this.state.id || undefined,
      sections: JSON.stringify(save),
      title: this.state.title,
      description: this.state.subtitle,
      status: status,
      cover_image_link: (firstResource && firstResource.data.image_src) || "",
      contributed_at: currentDate
    })
      .then(res => {
        console.log("res.uuid", res)
        this.setState({
          id: res.resource_id,
          saveState: SAVED,
          access_rights: res.access_rights
        })

        if (this.props.handleSave) {
          this.props.handleSave(res)
        }
      })
      .catch(err => {
        let message = err.message
        if (err && err.json && err.json.messages && err.json.messages.length) {
          message = err.json.messages.join("; ")
        }

        this.setState({
          saveState: UNSAVED,
          errors: { form: message }
        })
      })
  }
}

export default Relay.createContainer(injectIntl(Article), {
  fragments: {
    resource: () => Relay.QL`
      fragment on Resource {
        id
        title
        custom_fields
        updated_at
        creator
        type
        access_rights
        ${ArticleMetaShare.getFragment("resource")}
        ${ArticleMetaShare.getFragment("active")}
        files {
          contents
        }
      }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/modules/Article.js